module.exports = __webpack_public_path__ + "static/media/oceanview.178eb91d.svg";